// @ vendors
const { APIPost } = require('utilities/APIRequestHelper');
// @utilities
const { getLanguage } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');
const {
    COLLECTIVE_LANDING_CHANNEL,
    COLLECTIVE_LANDING_UI_COMPONENT,
} = require('constants/collectiveLanding');

const collectiveLandingProductListIsFetching = () => ({
    type: actionTypes.COLLECTIVE_LANDING_PRODUCT_LIST_IS_FETCHING,
});

const collectiveLandingProductListSuccess= (response) => ({
    type: actionTypes.COLLECTIVE_LANDING_PRODUCT_LIST_SUCCESS,
    payload: {
        response: response
    }
});

const collectiveLandingProductListError = (error) => ({
    type: actionTypes.COLLECTIVE_LANDING_PRODUCT_LIST_ERROR,
    payload: {
        error
    }
});

const getCollectiveLandingProductList = () => (dispatch) => {

    const requestData = {
        query: {
            channel: COLLECTIVE_LANDING_CHANNEL,
            uiComponentId: COLLECTIVE_LANDING_UI_COMPONENT,
            lang: getLanguage()
        }
    };

    dispatch(collectiveLandingProductListIsFetching());
    return APIPost({
        dispatch,
        endpoint: 'collectiveLandingProductList',
        params: requestData
    })
        .then(response => {
            dispatch(collectiveLandingProductListSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(collectiveLandingProductListError(response.error.description));
            } else {
                throw response;
            }
        });
}

module.exports = {
    getCollectiveLandingProductList,
};